<div class="timeExpiration">
  <div class="heading">
    <h4 class="text-center mb-5">Booking time expired</h4>
    <br>

    <p class="mb-2">To ensure availability and pricing accuracy, we limit booking sessions to a specific time.</p>
    <p>Please restart the booking process to complete your reservation.</p>
  </div>

  <button class="btn done mt-3" (click)="bookNow()">Book Now</button>
</div>
